import enumerate from 'lib/enumerate';

export const SCHEMA_VERSION_SUPPORTED = 2;

export const ResponseTypes = {
  PRIMARY_ACTION: 'primary',
  SECONDARY_ACTION: 'secondary',
  DISMISSED: 'dismissed',
};

export const PromotionTypes = enumerate([
  'MODAL',
  'INLINE',
  'TUTORING_SURVEY_MODAL',
  'CUSTOM',
  'UNKNOWN', // We don't recognize the promotion type. Don't show it.
]);

export const ImageTypes = enumerate([
  'IMAGE',
  'BANNER',
  'NONE',
  'LEFT_ICON',
  'RIGHT_ICON',
  'CENTER_HEADER',
  'UNKNOWN', // We don't recognize the promotion image display type. Don't show it.
]);

export const ButtonActionTypes = enumerate([
  'DEEPLINK',
  'LINK',
  'NONE',
  'UNKNOWN', // We don't recognize the promotion button action. Don't show it.
]);

export const TriggerTypes = enumerate([
  'APP_OPENED',
  'CLASSES_LIST_TOP',
  'REMINDBAR',
  'UNKNOWN', // We don't recognize the promotion trigger. Don't show it.
]);

export const ActionTypes = enumerate(['PROMOTION_DISMISSED']);
